import { BadgeCheck, ShieldCheck, WandSparkles } from "lucide-react";
import type { ReactNode } from "react";
import type { ItemAffix } from "./types";

export function EquipmentAffixRow({
  affix,
  value,
  implicit = false,
  actions,
  className = "",
}: {
  affix: ItemAffix;
  value: string;
  implicit?: boolean;
  actions?: ReactNode;
  className?: string;
}) {
  const mechanic = affix.mode === "mechanic";
  const grade = affix.rollGrade ?? "B";
  return (
    <span
      className={`affix-row ${implicit ? "implicit-affix" : ""} ${className}`}
      title={
        implicit ? "模板固有属性，不受重铸或洗炼影响" : mechanic ? affix.description : undefined
      }
    >
      {implicit ? (
        <ShieldCheck size={14} />
      ) : mechanic ? (
        <WandSparkles size={14} />
      ) : (
        <BadgeCheck size={14} />
      )}
      <span className="affix-copy">
        <span className="affix-name">
          {affix.name}
          {implicit && <small>固有</small>}
        </span>
        {mechanic && <span className="affix-description">{affix.description ?? "特殊机制"}</span>}
      </span>
      {!mechanic && (
        <small className={`affix-grade grade-${grade}`} title="词条评级">
          {grade}
        </small>
      )}
      {actions && <span className="affix-actions">{actions}</span>}
      {!mechanic && <strong className="affix-value">{value}</strong>}
    </span>
  );
}
